import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@amzn/meridian-tokens/base/font/amazon-ember.css';

import * as serviceWorker from './registerServiceWorker';

import App from './components/app/App';
import React from 'react';
import ReactDOM from 'react-dom';
import UserProfile from './global/user-profile';
import mockit from './mock';

if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development') && typeof mockit === 'function') {
  mockit();
}

UserProfile.authenticate();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
